<template>
  <div class="container">
    <el-carousel
      trigger="click"
      arrow="never"
      height="370px"
    >
      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img8.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">镜头垂直光伏组件</div>
              <div class="desc">
                无人机镜头垂直于光伏板，确保捕捉到光伏板的完整、正面视图，从而能够更准确地拍摄到光伏板的表面情况，如是否有污垢、损坏或其他异常情况。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img9.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">无需预先建模</div>
              <div class="desc">
                将无人机巡检的照片上传云平台，平台自动云端建模并进行缺陷分析。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img10.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">组件自动编号</div>
              <div class="desc">
                根据电站项目的分布，可将电站分区管理，基于组件所在的区域，再结合具体的行列定位，对组件进行编号。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img11.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">可见光+热红外双光识别</div>
              <div class="desc">
                将可见光和热红外识别技术结合用于光伏板缺陷检测，能够同时实现光伏板表面和内部缺陷的高效、准确识别。可识别的缺陷类别包括：点状热斑、全红热斑、横条状热斑、竖条状热斑、厚积尘、遮挡、鸟粪和破损。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img12.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">自动生成报告</div>
              <div class="desc">
                类型缺陷数量统计图表、电站地图、缺陷分布 、缺陷组件详细信息等。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="content-row">
          <div class="row-left">
            <div class="img-wrap">
              <img
                src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/product/function_img11.png"
                alt=""
              />
            </div>
          </div>
          <div class="row-right">
            <div class="block-text">
              <div class="title">自动定位故障并导航</div>
              <div class="desc">
                使用去消缺APP，选择具体故障可自动定位该故障准确位置，并显示运维人员和故障间的路线，运维人员可直接导航到故障位置，节省了大量的时间。
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="stylus" scoped>
/deep/.el-carousel__button {
    background-color: #E0E0E0;
}
/deep/.el-carousel__indicator.is-active button {
    background-color:#2372E9;
}
/deep/.el-carousel__indicators--horizontal {
    width:270px !important;
    display:flex;
    justify-content:center;
  }
  .content-row {
            display:flex;
            flex-direction: column;
            margin-bottom:4rem;
            >div {
                flex:1;
            }
            .img-wrap {
                display:flex;
                justify-content: center;
                align-items: center;
            }
            .row-left {
                .img-wrap {
                    max-height:314px !important;
                    overflow:hidden;
                    display:flex;
                    justify-content: center;
                    align-items: center;
                }
                img {
                    width:100%;
                }
            }
            .block-text {
                padding:17px 0 10px;
                .title {
                    color:#2372E9;
                    margin-bottom:10px;
                    font-size:18px;
                }
                .desc {
                    color:#333333;
                    line-height:30px;
                    font-size:14px;
                    line-height:20px !important;
                }
            }
        }
</style>
